import { render, staticRenderFns } from "./EcommerceStatisticsTotalSales.vue?vue&type=template&id=4c2b3cbe&"
import script from "./EcommerceStatisticsTotalSales.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatisticsTotalSales.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceStatisticsTotalSales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports